module.exports = __webpack_public_path__ + "static/media/pic-ht1.3828ad1e.jpg";